import { cellRenderParseData } from '../../../utils/functions';

const columnDataGridAdditionalSemi = [
  {
    dataField: 'productPlanDistr',
    caption: '№ SKU ПФ',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'taskDate',
    dataType: 'date',
    cellRender: cellRenderParseData,
    caption: 'Дата задания'
  }
];

export default columnDataGridAdditionalSemi;
